var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldPlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0V6.02C12 10.22 12 13 6.41 15.8L6 16L5.59 15.8C0 12.99 0 10.22 0 6.02V0H12ZM1.82 6.02C1.82 9.91 1.82 11.75 6 13.96V13.95C10.18 11.75 10.18 9.91 10.18 6.02V1.82H1.82V6.02ZM13.5 0H14V16H9.05C13.5 13.06 13.5 9.77 13.5 6.02V0Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H26C26.5523 0 27 0.447715 27 1V15C27 15.5523 26.5523 16 26 16H14V0Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6818 6.54543H18.7727V7.99998H19.8636V10.9091H18.7727V12.3636H22.5909V10.9091H21.6818V6.54543ZM20.5909 3.27271C19.8873 3.27271 19.3182 3.8418 19.3182 4.54543C19.3182 5.24907 19.8873 5.81816 20.5909 5.81816C21.2945 5.81816 21.8636 5.24907 21.8636 4.54543C21.8636 3.8418 21.2945 3.27271 20.5909 3.27271Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldPlatform);
export default __webpack_public_path__ + "static/media/shield-platform.29926cd5e8d6ff02d11d11db8b3fd1bd.svg";
export { ForwardRef as ReactComponent };